(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbb-boticario-brand"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root) {
    if (root.dataset.obReady) return;
    root.dataset.obReady = 'true';
    const q = s => root.querySelector(s);
    const grid = q('[data-ob-grid]');
    const cards = [...grid.querySelectorAll('[data-ob-product]')];
    const form = q('form');
    const range = form.elements.range;
    const type = form.elements.type;
    const sort = form.elements.sort;
    const count = q('[data-ob-count]');
    const status = q('[data-ob-status]');
    const more = q('[data-ob-more]');
    const norm = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const addOptions = (select, values) => [...new Set(values)].filter(Boolean).sort((a,b)=>a.localeCompare(b)).forEach(value => select.add(new Option(value,value)));
    addOptions(range, cards.map(c=>c.dataset.range));
    addOptions(type, cards.map(c=>c.dataset.type));
    let category = 'all', limit = 24, best = null, loading = false;
    let previousSort = 'featured';
    const tokens = (text, values) => text.replace(/__(COUNT|SHOWN|TOTAL)__/g, (_,key)=>values[key.toLowerCase()] ?? '');
    const buttons = [...root.querySelectorAll('[data-ob-category]')];
    buttons.forEach(button => {
      const key = button.dataset.obCategory;
      if (key !== 'all' && !cards.some(c=>c.dataset.category.split(' ').includes(key))) button.hidden = true;
      button.addEventListener('click', () => { category = key; limit = 24; render(); });
    });
    function render() {
      const search = norm(form.elements.search.value.trim());
      const min = form.elements.min.value === '' ? -Infinity : Number(form.elements.min.value)*100;
      const max = form.elements.max.value === '' ? Infinity : Number(form.elements.max.value)*100;
      const filtered = cards.filter(c => {
        const d = c.dataset;
        return (category === 'all' || d.category.split(' ').includes(category)) &&
          (!range.value || d.range === range.value) && (!type.value || d.type === type.value) &&
          (!form.elements.stock.checked || d.available === 'true') &&
          Number(d.price)>=min && Number(d.price)<=max && (!search || norm(d.title+' '+d.range+' '+d.type).includes(search));
      });
      filtered.sort((a,b) => {
        const x=a.dataset,y=b.dataset;
        switch(sort.value) {
          case 'price-ascending': return Number(x.price)-Number(y.price);
          case 'price-descending': return Number(y.price)-Number(x.price);
          case 'created-descending': return Number(y.date)-Number(x.date);
          case 'title-ascending': return x.title.localeCompare(y.title);
          case 'best-selling': return (best?.get(x.handle) ?? 9999)-(best?.get(y.handle) ?? 9999);
          default: return Number(x.index)-Number(y.index);
        }
      });
      cards.forEach(c=>c.hidden=true);
      filtered.forEach((c,i)=>{ grid.append(c); c.hidden=i>=limit; });
      count.textContent=tokens(root.dataset.count,{count:filtered.length});
      q('[data-ob-shown]').textContent=tokens(root.dataset.shown,{shown:Math.min(filtered.length,limit),total:filtered.length});
      q('[data-ob-empty]').hidden=filtered.length!==0;
      more.hidden=filtered.length<=limit;
      buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.obCategory===category)));
      const active = category!=='all'||range.value||type.value||search||min!==-Infinity||max!==Infinity||form.elements.stock.checked;
      q('[data-ob-reset]').hidden=!active;
      const activeNames=[category==='all'?'':buttons.find(b=>b.dataset.obCategory===category)?.textContent,range.value,type.value,search];
      q('[data-ob-active]').textContent=activeNames.filter(Boolean).join(' · ');
      root.dataset.visible=String(filtered.length);
      const params=new URLSearchParams(location.search);
      for (const key of ['category','range','type','search','min','max','sort','stock']) {
        const value = key==='category'?(category==='all'?'':category):key==='stock'?(form.elements.stock.checked?'1':''):form.elements[key].value;
        if (value && !(key==='sort'&&value==='featured')) params.set('ob_'+key,value); else params.delete('ob_'+key);
      }
      const query=params.toString();
      history.replaceState(null,'',location.pathname+(query?'?'+query:'')+location.hash);
    }
    async function loadBest() {
      if (best || loading) return;
      loading=true;sort.disabled=true;status.textContent=root.dataset.loading;
      try {
        const url=new URL(root.dataset.collection,location.origin);
        url.searchParams.set('section_id','lbb-boticario-brand');
        url.searchParams.set('sort_by','best-selling');
        const response=await fetch(url,{signal:AbortSignal.timeout(15000)});
        if(!response.ok)throw Error('Catalogue unavailable');
        const html=new DOMParser().parseFromString(await response.text(),'text/html');
        const sorted=[...html.querySelectorAll('[data-ob-product]')];
        if(sorted.length<cards.length)throw Error('Incomplete ranking');
        best=new Map(sorted.map((c,i)=>[c.dataset.handle,i]));
        status.textContent='';
      } catch { sort.value=previousSort;status.textContent=root.dataset.error; }
      finally {loading=false;sort.disabled=false;render();}
    }
    form.addEventListener('submit',e=>{e.preventDefault();limit=24;render();});
    form.addEventListener('input',e=>{if(e.target!==sort){limit=24;render();}});
    sort.addEventListener('change',async()=>{limit=24;if(sort.value==='best-selling')await loadBest();render();previousSort=sort.value;});
    q('[data-ob-reset]').addEventListener('click',()=>{form.reset();category='all';limit=24;status.textContent='';render();});
    more.addEventListener('click',()=>{const before=grid.querySelectorAll('[data-ob-product]:not([hidden])').length;limit+=24;render();const next=grid.querySelectorAll('[data-ob-product]:not([hidden])')[before];next?.querySelector('a')?.focus({preventScroll:true});});
    const filters=q('details');
    const mq=matchMedia('(min-width:750px)');
    filters.open=mq.matches;
    mq.addEventListener('change',e=>filters.open=e.matches);
    const params=new URLSearchParams(location.search);
    for(const key of ['range','type','search','min','max','sort'])if(params.has('ob_'+key))form.elements[key].value=params.get('ob_'+key);
    form.elements.stock.checked=params.get('ob_stock')==='1';
    const initial=params.get('ob_category');
    if(buttons.some(b=>b.dataset.obCategory===initial))category=initial;
    if(!sort.value)sort.value='featured';
    root.closest('.lbb-ob').querySelectorAll('[data-ob-jump]').forEach(link=>link.addEventListener('click',()=>{
      form.reset();category=link.dataset.obJump||'all';range.value=link.dataset.obRange||'';limit=24;render();
    }));
    root.classList.add('is-ready');render();
    if(sort.value==='best-selling')loadBest();
  }
  document.querySelectorAll('[data-ob-catalog]').forEach(setup);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ob-catalog]').forEach(setup));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbb-care-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lbb-care-guide')) {
    customElements.define('lbb-care-guide', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.controller) return;
          this.grid = this.querySelector('[data-grid]');
          if (!this.grid || Number(this.dataset.total) > 250) return;
          this.controller = new AbortController();
          this.cards = Array.from(this.grid.querySelectorAll('[data-product]'));
          this.cards.forEach((card, index) => { if (!card.hasAttribute('data-order')) card.dataset.order = String(index); });
          this.scent = this.querySelector('[data-scent]');
          const usedScents = new Set(this.cards.map(card => card.dataset.profile));
          Array.from(this.scent.options).forEach(option => { if (option.value !== 'all' && !usedScents.has(option.value)) option.remove(); });
          this.querySelector('[data-scent-field]').hidden = this.scent.options.length < 3;
          this.validScents = Array.from(this.scent.options).map(option => option.value);
          this.validCategories = ['all', ...new Set(this.cards.map(card => card.dataset.category).filter(Boolean))];
          this.querySelectorAll('button[data-category]').forEach(button => { button.hidden = !this.validCategories.includes(button.dataset.category); });
          this.sort = this.querySelector('[data-sort]');
          this.stock = this.querySelector('[data-stock]');
          this.count = this.querySelector('[data-count]');
          this.noResults = this.querySelector('[data-no-results]');
          this.collator = new Intl.Collator(document.documentElement.lang || 'fr', { sensitivity: 'base', numeric: true });
          const options = { signal: this.controller.signal };
          this.addEventListener('click', (event) => {
            const button = event.target.closest('button');
            if (!button || !this.contains(button)) return;
            if (button.hasAttribute('data-category')) {
              this.state.category = button.dataset.category;
              this.update(true);
            } else if (button.hasAttribute('data-reset')) {
              this.state = this.defaults();
              this.update(true);
              this.querySelector('[data-selection-heading]').focus({ preventScroll: true });
            }
          }, options);
          this.addEventListener('change', (event) => {
            if (event.target === this.scent) this.state.scent = this.scent.value;
            else if (event.target === this.sort) this.state.sort = this.sort.value;
            else if (event.target === this.stock) this.state.stock = this.stock.checked;
            else return;
            this.update(true);
          }, options);
          window.addEventListener('popstate', () => { this.readUrl(); this.update(false); }, options);
          this.readUrl();
          this.update(false);
          this.querySelectorAll('[data-enhanced-only]').forEach((element) => { element.hidden = false; });
          const categories = this.querySelector('.lbbcg__categories');
          if (this.validCategories.length < 3 && categories) categories.hidden = true;
        });
      }
      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
      defaults() { return { category: 'all', scent: 'all', sort: 'featured', stock: false }; }
      readUrl() {
        const params = new URL(window.location.href).searchParams;
        this.state = this.defaults();
        const category = params.get('lbb_category');
        const scent = params.get('lbb_scent');
        const sort = params.get('lbb_sort');
        if (this.validCategories.includes(category)) this.state.category = category;
        if (this.validScents.includes(scent)) this.state.scent = scent;
        if (['price_asc', 'price_desc', 'name'].includes(sort)) this.state.sort = sort;
        this.state.stock = params.get('lbb_stock') === '1';
      }
      update(writeUrl) {
        const state = this.state;
        this.scent.value = state.scent;
        this.sort.value = state.sort;
        this.stock.checked = state.stock;
        this.querySelectorAll('button[data-category]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.category === state.category));
        });
        const ordered = this.cards.slice().sort((a, b) => {
          if (state.sort === 'price_asc') return Number(a.dataset.price) - Number(b.dataset.price) || Number(a.dataset.order) - Number(b.dataset.order);
          if (state.sort === 'price_desc') return Number(b.dataset.price) - Number(a.dataset.price) || Number(a.dataset.order) - Number(b.dataset.order);
          if (state.sort === 'name') return this.collator.compare(a.dataset.name, b.dataset.name) || Number(a.dataset.order) - Number(b.dataset.order);
          return Number(a.dataset.order) - Number(b.dataset.order);
        });
        let visible = 0;
        const fragment = document.createDocumentFragment();
        ordered.forEach((card) => {
          card.hidden = (state.category !== 'all' && card.dataset.category !== state.category) || (state.scent !== 'all' && card.dataset.profile !== state.scent) || (state.stock && card.dataset.available !== 'true');
          if (!card.hidden) visible += 1;
          fragment.append(card);
        });
        this.grid.append(fragment);
        this.count.textContent = (visible === 1 ? this.dataset.countOne : this.dataset.countMany).replace('__COUNT__', String(visible));
        this.noResults.hidden = visible !== 0 || this.cards.length === 0;
        const changed = state.category !== 'all' || state.scent !== 'all' || state.sort !== 'featured' || state.stock;
        this.querySelectorAll('.lbbcg__results-row [data-reset]').forEach((button) => { button.hidden = !changed; });
        if (writeUrl) {
          const url = new URL(window.location.href);
          [['lbb_category', state.category, 'all'], ['lbb_scent', state.scent, 'all'], ['lbb_sort', state.sort, 'featured'], ['lbb_stock', state.stock ? '1' : '', '']].forEach(([key, value, fallback]) => {
            if (value === fallback) url.searchParams.delete(key);
            else url.searchParams.set(key, value);
          });
          if (url.href !== window.location.href) window.history.pushState(null, '', url);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbb-fragrance-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lbb-fragrance-guide')) {
    customElements.define('lbb-fragrance-guide', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.controller) return;
          this.grid = this.querySelector('[data-grid]');
          if (!this.grid) return;
          this.controller = new AbortController();
          this.cards = Array.from(this.grid.querySelectorAll('[data-product]'));
          this.cards.forEach((card, index) => { if (!card.hasAttribute('data-order')) card.dataset.order = String(index); });
          this.scent = this.querySelector('[data-scent]');
          this.sort = this.querySelector('[data-sort]');
          this.stock = this.querySelector('[data-stock]');
          this.count = this.querySelector('[data-count]');
          this.noResults = this.querySelector('[data-no-results]');
          this.collator = new Intl.Collator(document.documentElement.lang || 'fr', { sensitivity: 'base', numeric: true });
          const options = { signal: this.controller.signal };
          this.addEventListener('click', (event) => {
            const button = event.target.closest('button');
            if (!button || !this.contains(button)) return;
            if (button.hasAttribute('data-category')) {
              this.state.category = button.dataset.category;
              this.update(true);
            } else if (button.hasAttribute('data-reset')) {
              this.state = this.defaults();
              this.update(true);
              this.querySelector('[data-selection-heading]').focus({ preventScroll: true });
            }
          }, options);
          this.addEventListener('change', (event) => {
            if (event.target === this.scent) this.state.scent = this.scent.value;
            else if (event.target === this.sort) this.state.sort = this.sort.value;
            else if (event.target === this.stock) this.state.stock = this.stock.checked;
            else return;
            this.update(true);
          }, options);
          window.addEventListener('popstate', () => { this.readUrl(); this.update(false); }, options);
          this.readUrl();
          this.update(false);
          this.querySelectorAll('[data-enhanced-only]').forEach((element) => { element.hidden = false; });
        });
      }
      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
      }
      defaults() { return { category: 'all', scent: 'all', sort: 'featured', stock: false }; }
      readUrl() {
        const params = new URL(window.location.href).searchParams;
        this.state = this.defaults();
        const category = params.get('lbb_category');
        const scent = params.get('lbb_scent');
        const sort = params.get('lbb_sort');
        if (['women', 'men', 'body_splash'].includes(category)) this.state.category = category;
        if (['floral', 'fruity', 'gourmand', 'woody', 'aromatic'].includes(scent)) this.state.scent = scent;
        if (['price_asc', 'price_desc', 'name'].includes(sort)) this.state.sort = sort;
        this.state.stock = params.get('lbb_stock') === '1';
      }
      update(writeUrl) {
        const state = this.state;
        this.scent.value = state.scent;
        this.sort.value = state.sort;
        this.stock.checked = state.stock;
        this.querySelectorAll('button[data-category]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.category === state.category));
        });
        const ordered = this.cards.slice().sort((a, b) => {
          if (state.sort === 'price_asc') return Number(a.dataset.price) - Number(b.dataset.price) || Number(a.dataset.order) - Number(b.dataset.order);
          if (state.sort === 'price_desc') return Number(b.dataset.price) - Number(a.dataset.price) || Number(a.dataset.order) - Number(b.dataset.order);
          if (state.sort === 'name') return this.collator.compare(a.dataset.name, b.dataset.name) || Number(a.dataset.order) - Number(b.dataset.order);
          return Number(a.dataset.order) - Number(b.dataset.order);
        });
        let visible = 0;
        const fragment = document.createDocumentFragment();
        ordered.forEach((card) => {
          card.hidden = (state.category !== 'all' && card.dataset.category !== state.category) || (state.scent !== 'all' && card.dataset.profile !== state.scent) || (state.stock && card.dataset.available !== 'true');
          if (!card.hidden) visible += 1;
          fragment.append(card);
        });
        this.grid.append(fragment);
        this.count.textContent = (visible === 1 ? this.dataset.countOne : this.dataset.countMany).replace('__COUNT__', String(visible));
        this.noResults.hidden = visible !== 0 || this.cards.length === 0;
        const changed = state.category !== 'all' || state.scent !== 'all' || state.sort !== 'featured' || state.stock;
        this.querySelectorAll('.lbbfg__results-row [data-reset]').forEach((button) => { button.hidden = !changed; });
        if (writeUrl) {
          const url = new URL(window.location.href);
          [['lbb_category', state.category, 'all'], ['lbb_scent', state.scent, 'all'], ['lbb_sort', state.sort, 'featured'], ['lbb_stock', state.stock ? '1' : '', '']].forEach(([key, value, fallback]) => {
            if (value === fallback) url.searchParams.delete(key);
            else url.searchParams.set(key, value);
          });
          if (url.href !== window.location.href) window.history.pushState(null, '', url);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbb-home-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lbb-home-journey')) {
    customElements.define('lbb-home-journey', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.controller) return;
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
          const stopAll = () => this.querySelectorAll('[data-hover-video]').forEach((card) => {
            card.dataset.hovering = 'false';
            card.classList.remove('is-playing');
            card.querySelector('video')?.pause();
          });
          this.querySelectorAll('[data-hover-video]').forEach((card) => {
            const video = card.querySelector('video');
            if (!video) return;
            video.muted = true;
            const stop = () => {
              card.dataset.hovering = 'false';
              card.classList.remove('is-playing');
              video.pause();
            };
            card.addEventListener('pointerenter', async (event) => {
              if (event.pointerType !== 'mouse' || !finePointer.matches || reducedMotion.matches || document.hidden) return;
              card.dataset.hovering = 'true';
              try {
                await video.play();
                if (card.dataset.hovering === 'true' && !reducedMotion.matches && !document.hidden) card.classList.add('is-playing');
                else video.pause();
              } catch { card.classList.remove('is-playing'); }
            }, options);
            card.addEventListener('pointerleave', stop, options);
            card.addEventListener('pointercancel', stop, options);
          });
          document.addEventListener('visibilitychange', () => { if (document.hidden) stopAll(); }, options);
          reducedMotion.addEventListener('change', () => { if (reducedMotion.matches) stopAll(); }, options);
          finePointer.addEventListener('change', () => { if (!finePointer.matches) stopAll(); }, options);
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.querySelectorAll('video').forEach((video) => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbb-lissage-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (scope) => {
      scope.querySelectorAll('[data-lissage-compact]').forEach((root) => {
        if (root.dataset.lissageReady) return;
        root.dataset.lissageReady = 'true';
        const comparison = root.querySelector('.lbbg-compact__comparison');
        const intent = root.querySelector('[data-lissage-intent]');
        const syncFormula = (focus = false) => {
          const requested = new URLSearchParams(window.location.search).get('lbb_formula');
          const formula = ['single', 'duo', 'complete'].includes(requested) ? requested : '';
          if (formula) root.dataset.lbbFormula = formula;
          else delete root.dataset.lbbFormula;
          const requestedOffer = new URLSearchParams(window.location.search).get('lbb_offer');
          const offer = ['ready', 'build'].includes(requestedOffer) ? requestedOffer : '';
          if (!formula && offer) root.dataset.lbbOffer = offer;
          else delete root.dataset.lbbOffer;
          if (comparison) comparison.open = formula === 'single' || location.hash === '#' + comparison.id;
          if (focus) requestAnimationFrame(() => {
            const target = formula ? intent : offer === 'ready' ? root.querySelector('#kits-deja-composes') : offer === 'build' ? root.querySelector('#composer-mon-kit-lissage') : root.querySelector('.lbbg-offer__paths');
            target?.setAttribute('tabindex', '-1');
            target?.focus({ preventScroll: true });
            target?.scrollIntoView({ block: 'start', behavior: 'auto' });
          });
        };
        root.querySelector('[data-lissage-reset]')?.addEventListener('click', (event) => {
          event.preventDefault();
          const url = new URL(window.location.href);
          url.searchParams.delete('lbb_formula');
          url.searchParams.delete('lbb_offer');
          url.hash = '';
          history.pushState(null, '', url);
          syncFormula(true);
        });
        root.querySelector('.lbbg-compact__back')?.addEventListener('click', (event) => {
          if (!root.dataset.lbbFormula) return;
          event.preventDefault();
          root.querySelector('[data-lissage-reset]')?.click();
        });
        root.querySelector('[data-lissage-show-ready]')?.addEventListener('click', (event) => {
          event.preventDefault();
          const url = new URL(window.location.href);
          url.searchParams.delete('lbb_formula');
          url.searchParams.set('lbb_offer', 'ready');
          url.hash = 'kits-deja-composes';
          history.pushState(null, '', url);
          syncFormula(true);
        });
        syncFormula(Boolean(root.dataset.lbbFormula || root.dataset.lbbOffer));
        window.addEventListener('popstate', () => syncFormula(true));
        const openComparison = () => { if (comparison) comparison.open = true; };
        root.querySelectorAll('[data-lissage-open-comparison]').forEach((link) => {
          link.addEventListener('click', () => {
            openComparison();
            requestAnimationFrame(() => comparison?.querySelector('summary')?.focus({ preventScroll: true }));
          });
        });
        const syncHash = () => {
          if (location.hash === '#' + comparison?.id) openComparison();
        };
        syncHash();
        window.addEventListener('hashchange', syncHash);
      });
    };
    setup(document);
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbb-routine-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lbb-routine-builder')) {
    class LbbRoutineBuilder extends HTMLElement {
      static plan(selections, kits) {
        const chosen = selections.filter(Boolean);
        const baseTotal = chosen.reduce((total, item) => total + item.variant.price, 0);
        let result = { total: baseTotal, baseTotal, items: chosen.map(item => ({ id: item.variant.id, quantity: 1 })), kit: null, covered: [] };
        const duo = chosen.find(item => item.product.step === 'duo');
        if (!duo || chosen.some(item => !item.variant.available)) return result;
        const selectedIds = chosen.map(item => item.variant.id);
        for (const kit of kits) {
          const ids = kit.components;
          if (!kit.variant.available || !Number.isFinite(kit.variant.price) || ids.length < 2 || new Set(ids).size !== ids.length || !ids.includes(duo.variant.id) || !ids.every(id => selectedIds.includes(id))) continue;
          const remaining = chosen.filter(item => !ids.includes(item.variant.id));
          const total = kit.variant.price + remaining.reduce((sum, item) => sum + item.variant.price, 0);
          if (total < result.total) result = { total, baseTotal, items: [{ id: kit.variant.id, quantity: 1 }, ...remaining.map(item => ({ id: item.variant.id, quantity: 1 }))], kit, covered: ids };
        }
        return result;
      }
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        try { this.data = JSON.parse(this.querySelector('[data-builder-data]').textContent); } catch { return; }
        this.strings = this.data.strings;
        this.products = new Map(this.data.products.map(product => [product.id, product]));
        this.steps = ['duo', 'mask', 'finish', 'fragrance'];
        this.selection = Object.fromEntries(this.steps.map(step => [step, '']));
        this.form = this.querySelector('[data-builder-form]');
        this.submit = this.querySelector('[data-submit]');
        this.message = this.querySelector('[data-message]');
        this.cartLink = this.querySelector('[data-cart-link]');
        this.money = new Intl.NumberFormat(this.data.locale, { style: 'currency', currency: this.data.currency });
        this.events = new AbortController();
        this.addEventListener('change', event => this.onChange(event), { signal: this.events.signal });
        this.addEventListener('click', event => this.onClick(event), { signal: this.events.signal });
        this.form.addEventListener('submit', event => { event.preventDefault(); this.addRoutine(); }, { signal: this.events.signal });
        window.addEventListener('resize', () => this.updateSummaryLayout(), { signal: this.events.signal });
        if (typeof ResizeObserver !== 'undefined') {
          this.summaryObserver = new ResizeObserver(() => this.updateSummaryLayout());
          this.summaryObserver.observe(this.querySelector('.lbbrb__summary'));
        }
        this.render();
      }
      disconnectedCallback() { this.events?.abort(); this.summaryObserver?.disconnect(); this.ready = false; }
      updateSummaryLayout() {
        const summary = this.querySelector('.lbbrb__summary');
        if (!summary) return;
        const top = parseFloat(getComputedStyle(summary).top) || 140;
        const available = window.innerHeight - top - 88;
        summary.classList.toggle('is-tall-summary', summary.getBoundingClientRect().height > available);
      }
      price(value) { return this.money.format(value / 100); }
      selected() {
        return this.steps.map(step => {
          const product = this.products.get(this.selection[step]);
          if (!product) return null;
          const select = this.querySelector(`[data-variant="${product.id}"]`);
          const variant = product.variants.find(item => item.id === (select ? select.value : product.defaultVariant));
          return variant ? { product, variant } : null;
        }).filter(Boolean);
      }
      format(item) { return item.product.defaultOnly ? item.product.format : item.variant.title; }
      element(tag, className, text) { const node = document.createElement(tag); if (className) node.className = className; if (text !== undefined) node.textContent = text; return node; }
      onChange(event) {
        if (this.busy || this.uncertain) return;
        const choice = event.target.closest('[data-choice]');
        const variantSelect = event.target.closest('[data-variant]');
        if (choice) this.selection[choice.dataset.choiceStep] = choice.value;
        if (variantSelect) {
          const product = this.products.get(variantSelect.dataset.variant);
          if (product) { this.selection[product.step] = product.id; this.querySelector(`[data-choice][value="${product.id}"]`).checked = true; }
        }
        this.message.hidden = true;
        this.cartLink.hidden = true;
        this.render(true);
      }
      onClick(event) {
        const next = event.target.closest('[data-next-step]');
        if (next) this.showStep(next.dataset.nextStep);
        const remove = event.target.closest('[data-remove]');
        if (remove && !this.busy && !this.uncertain) {
          const step = remove.dataset.remove;
          this.selection[step] = '';
          this.querySelectorAll(`[data-choice-step="${step}"]`).forEach(input => { input.checked = input.value === ''; });
          this.render(true);
          this.showStep(step);
        }
        if (event.target.closest('[data-show-summary]')) {
          this.querySelector('.lbbrb__summary').scrollIntoView({ behavior: this.scrollBehavior(), block: 'start' });
          this.querySelector('.lbbrb__summary').focus({ preventScroll: true });
        }
      }
      scrollBehavior() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      showStep(step) {
        const details = this.querySelector(`[data-step="${step}"]`);
        if (!details) return;
        details.open = true;
        details.scrollIntoView({ behavior: this.scrollBehavior(), block: 'start' });
        details.querySelector('summary').focus({ preventScroll: true });
      }
      render(announce = false) {
        const chosen = this.selected();
        const plan = LbbRoutineBuilder.plan(chosen, this.data.kits);
        this.currentPlan = plan;
        const list = this.querySelector('[data-summary-list]');
        list.replaceChildren();
        for (const item of chosen) {
          const row = this.element('li', 'lbbrb__summary-item');
          if (item.product.image) { const img = this.element('img'); img.src = item.product.image; img.alt = ''; img.width = 54; img.height = 65; row.append(img); } else row.append(this.element('span'));
          const copy = this.element('div', 'lbbrb__summary-copy');
          copy.append(this.element('strong', '', item.product.name));
          if (this.format(item)) copy.append(this.element('span', '', this.format(item)));
          copy.append(this.element('b', '', this.price(item.variant.price)));
          if (!item.variant.available) copy.append(this.element('span', '', this.strings.unavailable));
          row.append(copy);
          const remove = this.element('button', 'lbbrb__remove', '×');
          remove.type = 'button'; remove.dataset.remove = item.product.step; remove.setAttribute('aria-label', `${this.strings.remove} ${item.product.name}`); remove.disabled = !!this.busy || !!this.uncertain;
          row.append(remove); list.append(row);
        }
        this.querySelector('[data-summary-empty]').hidden = chosen.length > 0;
        this.querySelector('[data-total]').textContent = this.price(plan.total);
        this.querySelector('[data-mobile-total]').textContent = this.price(plan.total);
        this.querySelector('[data-mobile-bar]').hidden = chosen.length === 0;
        const kitNote = this.querySelector('[data-kit-note]');
        kitNote.hidden = !plan.kit;
        if (plan.kit) kitNote.textContent = this.strings.kit_note.replace('__AMOUNT__', this.price(plan.baseTotal - plan.total));
        const hasDuo = chosen.some(item => item.product.step === 'duo');
        this.submit.disabled = !hasDuo || chosen.some(item => !item.variant.available) || !!this.busy || !!this.uncertain;
        if (!this.busy) this.submit.textContent = this.strings.add;
        this.querySelector('[data-required-note]').hidden = hasDuo;
        for (const step of this.steps) {
          const selected = chosen.find(item => item.product.step === step);
          this.querySelector(`[data-step-caption="${step}"]`).textContent = selected ? selected.product.name : (step === 'duo' ? this.strings.required : this.strings[`none_${step}`]);
        }
        for (const product of this.products.values()) {
          const select = this.querySelector(`[data-variant="${product.id}"]`);
          const variant = product.variants.find(item => item.id === (select ? select.value : product.defaultVariant));
          if (variant) this.querySelector(`[data-card-price="${product.id}"]`).textContent = this.price(variant.price);
          const available = product.variants.some(item => item.available);
          this.querySelector(`[data-card="${product.id}"]`).classList.toggle('is-unavailable', !available);
          this.querySelector(`[data-choice][value="${product.id}"]`).disabled = !available || !!this.busy || !!this.uncertain;
          this.querySelector(`[data-card-stock="${product.id}"]`).textContent = available ? '' : this.strings.unavailable;
          if (select) { select.disabled = !available || !!this.busy || !!this.uncertain; for (const option of select.options) option.disabled = !product.variants.find(item => item.id === option.value)?.available; }
        }
        this.querySelectorAll('[data-choice][value=""]').forEach(input => { input.disabled = !!this.busy || !!this.uncertain; });
        this.updateSummaryLayout();
        if (announce) this.querySelector('[data-announcement]').textContent = `${this.strings.summary_updated} ${this.price(plan.total)}`;
      }
      report(text, cart = false) {
        this.message.textContent = text; this.message.hidden = false; this.cartLink.hidden = !cart; this.message.focus({ preventScroll: true });
      }
      async refresh(chosen, plan) {
        const urls = new Set(chosen.map(item => item.product.url));
        const selectedIds = chosen.map(item => item.variant.id);
        const duo = chosen.find(item => item.product.step === 'duo');
        for (const kit of this.data.kits) {
          const ids = kit.components;
          if (duo && ids.length >= 2 && new Set(ids).size === ids.length && ids.includes(duo.variant.id) && ids.every(id => selectedIds.includes(id))) urls.add(kit.url);
        }
        const resources = await Promise.all([...urls].map(async url => {
          const endpoint = new URL(url, window.location.origin); endpoint.pathname += '.js'; endpoint.search = '';
          const controller = new AbortController(); const timer = setTimeout(() => controller.abort(), 15000);
          try {
            const response = await fetch(endpoint, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
            if (!response.ok) throw new Error('refresh');
            const fresh = await response.json();
            if (!Array.isArray(fresh.variants)) throw new Error('refresh');
            return { url, fresh };
          } finally { clearTimeout(timer); }
        }));
        let priceChanged = false;
        for (const { url, fresh } of resources) {
          const variants = new Map(fresh.variants.map(variant => [String(variant.id), variant]));
          for (const product of this.products.values()) {
            if (product.url !== url) continue;
            for (const variant of product.variants) {
              const current = variants.get(variant.id);
              const newPrice = Number(current?.price);
              if (Number.isFinite(newPrice) && newPrice !== variant.price) priceChanged = true;
              if (Number.isFinite(newPrice)) variant.price = newPrice;
              variant.available = !!current?.available && !fresh.requires_selling_plan;
            }
          }
          for (const kit of this.data.kits) {
            if (kit.url !== url) continue;
            const current = variants.get(kit.variant.id);
            const newPrice = Number(current?.price);
            if (Number.isFinite(newPrice) && newPrice !== kit.variant.price) priceChanged = true;
            if (Number.isFinite(newPrice)) kit.variant.price = newPrice;
            kit.variant.available = !!current?.available && !fresh.requires_selling_plan;
          }
        }
        return { priceChanged };
      }
      async addRoutine() {
        if (this.busy || this.uncertain) return;
        const chosen = this.selected();
        if (!chosen.some(item => item.product.step === 'duo')) { this.report(this.strings.choose_duo); this.showStep('duo'); return; }
        if (chosen.some(item => !item.variant.available)) { this.report(this.strings.stock_changed); return; }
        this.busy = true; this.message.hidden = true; this.cartLink.hidden = true; this.form.setAttribute('aria-busy', 'true');
        this.render(); this.submit.textContent = this.strings.checking;
        let posted = false;
        try {
          const oldPlan = LbbRoutineBuilder.plan(chosen, this.data.kits);
          const refreshed = await this.refresh(chosen, oldPlan);
          const newPlan = LbbRoutineBuilder.plan(this.selected(), this.data.kits);
          if (this.selected().some(item => !item.variant.available)) { this.report(this.strings.stock_changed); return; }
          if (refreshed.priceChanged || oldPlan.total !== newPlan.total || JSON.stringify(oldPlan.items) !== JSON.stringify(newPlan.items)) { this.report(this.strings.price_changed); return; }
          this.submit.textContent = this.strings.adding;
          posted = true;
          const controller = new AbortController(); const timer = setTimeout(() => controller.abort(), 20000);
          let response;
          try { response = await fetch(this.data.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: newPlan.items }), signal: controller.signal }); } finally { clearTimeout(timer); }
          const result = await response.json();
          if (!response.ok || result.status) { this.uncertain = true; this.report(this.strings.cart_error, true); return; }
          this.uncertain = true;
          this.report(this.strings.success, true);
          window.location.assign(this.data.cartUrl);
        } catch {
          if (posted) { this.uncertain = true; this.report(this.strings.cart_unknown, true); } else this.report(this.strings.check_failed);
        } finally { this.busy = false; this.form.removeAttribute('aria-busy'); this.render(); }
      }
    }
    customElements.define('lbb-routine-builder', LbbRoutineBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbb-routine-catalog"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('.lbbrc__filters');
    const grid = root.querySelector('.lbbrc__grid');
    const cards = [...grid.querySelectorAll('[data-price]')];
    const count = root.querySelector('[data-result-count]');
    const empty = root.querySelector('.lbbrc__empty');
    const update = () => {
      const need = form.elements.need.value;
      const brand = form.elements.brand.value;
      const raw = form.elements.budget.value;
      const budget = raw === '' ? Infinity : Math.round(Math.max(0, Number(raw)) * 100);
      const sort = form.elements.sort.value;
      let visible = 0;
      cards.sort((a,b) => sort === 'asc' ? Number(a.dataset.price)-Number(b.dataset.price) : sort === 'desc' ? Number(b.dataset.price)-Number(a.dataset.price) : Number(a.dataset.index)-Number(b.dataset.index));
      cards.forEach(card => {
        card.hidden = Boolean((need && !card.dataset.need.split(',').includes(need)) || (brand && card.dataset.brand !== brand) || Number(card.dataset.price) > budget);
        if (!card.hidden) visible++;
        grid.append(card);
      });
      count.textContent = visible;
      empty.hidden = visible !== 0;
    };
    form.hidden = false;
    form.addEventListener('submit', event => event.preventDefault());
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('reset', () => requestAnimationFrame(update));
    root.querySelector('[data-clear-filters]').addEventListener('click', () => { form.reset(); form.elements.need.focus(); });
    const purchaseButtons = [...root.querySelectorAll('[data-duo-add] button')].map(element => ({element, disabled:element.disabled, text:element.textContent}));
    window.addEventListener('pageshow', event => {
      update();
      if (!event.persisted) return;
      root.dataset.cartBusy = 'false';
      purchaseButtons.forEach(({element, disabled, text}) => { element.disabled = disabled; element.textContent = text; });
      root.querySelectorAll('[data-duo-add]').forEach(addForm => addForm.removeAttribute('aria-busy'));
    });
    root.querySelectorAll('[data-duo-add]').forEach(addForm => {
      addForm.addEventListener('submit', async event => {
        event.preventDefault();
        if (root.dataset.cartBusy === 'true') return;
        root.dataset.cartBusy = 'true';
        const button = addForm.querySelector('button');
        const buttons = [...root.querySelectorAll('[data-duo-add] button')].map(element => ({element, disabled:element.disabled}));
        const originalText = button.textContent;
        const message = addForm.querySelector('.lbbrc__message');
        const cartLink = addForm.querySelector('.lbbrc__cart-link');
        buttons.forEach(({element}) => { element.disabled = true; });
        addForm.setAttribute('aria-busy', 'true');
        button.textContent = addForm.dataset.adding;
        message.textContent = '';
        cartLink.hidden = true;
        try {
          const response = await fetch(addForm.action + '.js', {method:'POST', headers:{Accept:'application/json'}, body:new FormData(addForm)});
          const data = await response.json();
          if (!response.ok || data.status) throw new Error('Cart add failed');
          message.textContent = addForm.dataset.success;
          window.location.assign(addForm.dataset.cartUrl);
        } catch (error) {
          message.textContent = addForm.dataset.error;
          cartLink.hidden = false;
          button.textContent = originalText;
          buttons.forEach(({element, disabled}) => { element.disabled = disabled; });
          root.dataset.cartBusy = 'false';
          addForm.removeAttribute('aria-busy');
        }
      });
    });
    update();
  };
  const scan = () => document.querySelectorAll('[data-routine-catalog]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbb-routine-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (scope) => scope.querySelectorAll('[data-routine-hub]').forEach((root) => {
    if (root.dataset.intentReady) return;
    root.dataset.intentReady = 'true';
    const sync = (focus = false) => {
      const single = new URLSearchParams(window.location.search).get('lbb_selection') === 'single';
      if (single) root.dataset.lbbSelection = 'single';
      else delete root.dataset.lbbSelection;
      if (focus) requestAnimationFrame(() => {
        const target = root.querySelector(single ? '.lbbh__single-intent h2' : '.lbbh__prompt');
        target?.setAttribute('tabindex', '-1');
        target?.focus({ preventScroll: true });
        target?.closest('section,nav')?.scrollIntoView({ block: 'start', behavior: 'auto' });
      });
    };
    root.querySelector('[data-routine-reset]')?.addEventListener('click', (event) => {
      event.preventDefault();
      const url = new URL(window.location.href);
      url.searchParams.delete('lbb_selection');
      url.hash = '';
      history.pushState(null, '', url);
      sync(true);
    });
    sync(Boolean(root.dataset.lbbSelection));
    window.addEventListener('popstate', () => sync(true));
  });
  setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
if (!customElements.get('lbb-hover-video')) {
  class LbbHoverVideo extends HTMLElement {
    static active = null;

    connectedCallback() {
      if (this.controller) return;
      this.card = this.closest('.lbbh__choice');
      this.video = this.querySelector('video');
      if (!this.card || !this.video?.dataset.src) return;
      this.controller = new AbortController();
      this.sequence = 0;
      this.requested = false;
      this.hovered = false;
      this.focused = false;
      this.dismissed = false;
      this.failed = false;
      this.visible = true;
      this.media = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
      this.connection = navigator.connection;
      const options = { signal: this.controller.signal };

      this.card.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch') return;
        this.hovered = true;
        this.dismissed = false;
        this.start();
      }, options);
      this.card.addEventListener('pointerleave', () => {
        this.hovered = false;
        if (!this.focused) this.stop();
      }, options);
      this.card.addEventListener('focus', () => {
        this.focused = this.card.matches(':focus-visible');
        if (!this.focused) return;
        this.dismissed = false;
        this.start();
      }, options);
      this.card.addEventListener('blur', () => {
        this.focused = false;
        if (!this.hovered) this.stop();
      }, options);
      this.card.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        this.dismissed = true;
        this.stop();
      }, options);
      this.video.addEventListener('playing', () => {
        if (this.requested && this.eligible()) {
          this.card.classList.add('is-video-playing');
        } else {
          this.stop();
        }
      }, options);
      this.video.addEventListener('error', () => {
        this.failed = true;
        this.stop();
      }, options);
      this.media.addEventListener('change', () => {
        if (!this.eligible()) this.stop();
      }, options);
      this.connection?.addEventListener('change', () => {
        if (!this.eligible()) this.stop();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
      }, options);
      window.addEventListener('blur', () => this.stop(), options);
      window.addEventListener('pagehide', () => this.stop(), options);
      this.observer = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.1;
        if (!this.visible) this.stop();
      }, { threshold: [0, 0.1] });
      this.observer.observe(this.card);
    }

    eligible() {
      return this.isConnected && this.media.matches && !this.connection?.saveData &&
        !document.hidden && this.visible && !this.dismissed && !this.failed &&
        (this.hovered || this.focused);
    }

    start() {
      if (!this.eligible() || this.requested) return;
      if (LbbHoverVideo.active && LbbHoverVideo.active !== this) {
        LbbHoverVideo.active.stop();
      }
      LbbHoverVideo.active = this;
      this.requested = true;
      const sequence = ++this.sequence;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      if (!this.video.hasAttribute('src')) {
        this.video.src = this.video.dataset.src;
        this.video.load();
      }
      try {
        Promise.resolve(this.video.play()).then(() => {
          if (sequence !== this.sequence) {
            if (!this.requested) this.video.pause();
            return;
          }
          if (!this.requested || !this.eligible()) {
            this.stop();
            return;
          }
          this.card.classList.add('is-video-playing');
        }).catch(() => {
          if (sequence === this.sequence) this.stop();
        });
      } catch {
        this.stop();
      }
    }

    stop() {
      this.sequence += 1;
      this.requested = false;
      this.video?.pause();
      this.card?.classList.remove('is-video-playing');
      if (this.video?.readyState > 0) {
        try { this.video.currentTime = 0; } catch {}
      }
      if (LbbHoverVideo.active === this) LbbHoverVideo.active = null;
    }

    disconnectedCallback() {
      this.stop();
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  }
  customElements.define('lbb-hover-video', LbbHoverVideo);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbb-routine-guided"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lbb-guided-routine')) {
    class LbbGuidedRoutine extends HTMLElement {
      static families = [{"key":"d_inc","masks":["m_inc","m_tanino200"],"finishes":["f_oil","f_leavein","f_reverse"],"route":"e"},{"key":"d_coconut","masks":["m_coconut200","m_coconut500"],"finishes":["f_oil","f_leavein","f_reverse"],"route":"a"},{"key":"d_tanino","masks":["m_tanino200","m_tanino500"],"finishes":["f_reverse","f_oil"],"route":"b"},{"key":"d_mais","masks":["m_mais"],"finishes":["f_reverse","f_bomba"],"route":"c"},{"key":"d_crespo","masks":["m_crespos"],"finishes":["f_crespo","f_cachos"],"route":"a"},{"key":"d_bomba","masks":["m_bomba"],"finishes":["f_bomba","f_reverse"],"route":"d"},{"key":"d_match","masks":["m_inc","m_glossy"],"finishes":["f_reverse","f_oil"],"route":"a"},{"key":"d_lily","masks":["m_glossy","m_coconut200"],"finishes":["f_oil","f_reverse"],"route":"a"}];
      static kits = [{"kit":"k_oil","includes":["d_inc","f_oil"]},{"kit":"k_leavein","includes":["d_inc","f_leavein"]},{"kit":"k_inc_tanino","includes":["d_inc","m_tanino200"]},{"kit":"k_mais","includes":["d_mais","m_mais"]},{"kit":"k_bomba","includes":["d_bomba","m_bomba"]},{"kit":"k_tanino","includes":["d_tanino","m_tanino200"]}];
      static levels = ['essentiel', 'rituel', 'complete'];
      static fragrances = ['p_rayhanete', 'p_nuvem', 'p_deleite', 'p_ameixa'];
      static resolve(catalog, selectedAliases) {
        const selected = [...new Set(selectedAliases.filter(Boolean))];
        const valid = alias => {
          const item = catalog[alias];
          return item && /^\d+$/.test(item.id || '') && Number.isInteger(item.price) && item.price > 0;
        };
        const matching = this.kits.filter(kit => kit.includes.every(alias => selected.includes(alias)));
        const required = [...selected, ...matching.map(kit => kit.kit)];
        if (!selected.length || required.some(alias => !valid(alias))) {
          return { aliases: selected, total: null, available: false, missing: true, usesKit: false };
        }
        const candidates = [selected, ...matching.map(kit => [
          kit.kit, ...selected.filter(alias => !kit.includes.includes(alias))
        ])].map(aliases => ({
          aliases,
          total: aliases.reduce((sum, alias) => sum + catalog[alias].price, 0),
          usesKit: aliases.some(alias => alias.startsWith('k_'))
        }));
        const result = candidates.reduce((best, item) =>
          item.total < best.total || (item.total === best.total && item.usesKit) ? item : best
        );
        return { ...result, available: result.aliases.every(alias => catalog[alias].available === true), missing: false };
      }
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        try {
          this.config = JSON.parse(this.querySelector('[data-routine-data]').textContent);
          this.catalog = Object.fromEntries(this.config.catalog.map(item => [item.alias, item]));
          this.text = this.config.text;
          this.money = new Intl.NumberFormat(this.config.locale || 'fr', {
            style: 'currency', currency: this.config.currency || 'EUR'
          });
          this.state = { family: null, formula: null, mask: null, finish: null, fragrance: null };
          this.lock = null;
          this.cartChecked = false;
          this.onClick = event => this.handleClick(event);
          this.onChange = event => this.handleChange(event);
          this.addEventListener('click', this.onClick);
          this.addEventListener('change', this.onChange);
          this.refreshFamilyControls();
        } catch {
          this.querySelector('[data-loading-error]').hidden = false;
        }
      }
      disconnectedCallback() {
        if (this.onClick) this.removeEventListener('click', this.onClick);
        if (this.onChange) this.removeEventListener('change', this.onChange);
        delete this.dataset.initialized;
      }
      el(tag, className, value) {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (value !== undefined && value !== null) node.textContent = value;
        return node;
      }
      q(selector) { return this.querySelector(selector); }
      format(value) { return Number.isInteger(value) ? this.money.format(value / 100) : '—'; }
      name(alias) {
        const item = this.catalog[alias];
        if (!item?.title) return this.text.missing;
        const variant = item.variantTitle && item.variantTitle !== 'Default Title' ? ' — ' + item.variantTitle : '';
        return item.title + variant;
      }
      focusStep(node) {
        if (!node) return;
        node.focus({ preventScroll: true });
        node.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
      family() { return LbbGuidedRoutine.families.find(item => item.key === this.state.family); }
      defaults(level) {
        const family = this.family();
        return [family.key, level !== 'essentiel' ? family.masks[0] : null, level === 'complete' ? family.finishes[0] : null].filter(Boolean);
      }
      selection() {
        return [this.state.family, this.state.mask, this.state.finish, this.state.fragrance].filter(Boolean);
      }
      changeStarted() {
        if (this.lock === 'success') {
          this.lock = null;
          this.q('[data-status]').textContent = '';
          this.q('[data-cart-link]').hidden = true;
          this.q('[data-reset]').hidden = true;
          this.q('[data-reset-note]').hidden = true;
        }
      }
      handleClick(event) {
        const target = event.target.closest('button, a');
        if (!target || !this.contains(target)) return;
        if (target.matches('[data-cart-link]') && this.lock === 'uncertain') {
          this.cartChecked = true;
          this.q('[data-unlock]').disabled = false;
          return;
        }
        if (this.lock === 'adding') return;
        if (target.matches('[data-family-choice]')) {
          this.chooseFamily(target.dataset.familyChoice);
        } else if (target.matches('[data-formula-choice]')) {
          this.chooseFormula(target.dataset.formulaChoice);
        } else if (target.matches('[data-add]')) {
          this.addRoutine();
        } else if (target.matches('[data-reset]')) {
          this.changeStarted();
          this.renderSelection();
          this.focusStep(this.q('[data-detail-heading]'));
        } else if (target.matches('[data-unlock]') && this.cartChecked) {
          this.lock = null;
          this.cartChecked = false;
          this.q('[data-status]').textContent = '';
          this.q('[data-unlock]').hidden = true;
          this.q('[data-unlock-note]').hidden = true;
          this.q('[data-cart-link]').hidden = true;
          this.renderSelection();
        }
      }
      handleChange(event) {
        const control = event.target.closest('[data-option]');
        if (!control || this.lock === 'adding' || !this.state.formula) return;
        const key = control.dataset.option;
        const value = control.value || null;
        const family = this.family();
        const choices = key === 'mask' ? family.masks : key === 'finish' ? family.finishes : LbbGuidedRoutine.fragrances;
        if (value && !choices.includes(value)) return;
        if (!value && key !== 'fragrance') return;
        this.changeStarted();
        this.state[key] = value;
        this.renderSelection();
        this.q('[data-announcement]').textContent = this.text.selection_announcement;
      }
      chooseFamily(alias) {
        if (!LbbGuidedRoutine.families.some(item => item.key === alias)) return;
        this.changeStarted();
        this.state = { family: alias, formula: null, mask: null, finish: null, fragrance: null };
        this.refreshFamilyControls();
        this.q('[data-chosen-family]').textContent = this.text[alias];
        this.q('[data-formula-section]').hidden = false;
        this.q('[data-detail-section]').hidden = true;
        this.renderFormulaCards();
        this.renderBundleLink();
        this.focusStep(this.q('[data-formula-heading]'));
      }
      refreshFamilyControls() {
        this.querySelectorAll('[data-family-choice]').forEach(button => {
          const selected = button.dataset.familyChoice === this.state.family;
          button.setAttribute('aria-pressed', String(selected));
          button.querySelector('[data-family-action]').textContent = selected ? this.text.selected : this.text.choose;
          button.disabled = this.lock === 'adding' || !this.catalog[button.dataset.familyChoice]?.id;
        });
      }
      image(alias, className = '') {
        const item = this.catalog[alias];
        if (!item?.image) return this.el('span', 'lbbgr__image-placeholder', this.text.image_missing);
        const img = this.el('img', className);
        img.src = item.image;
        img.alt = this.name(alias);
        img.loading = 'lazy';
        if (item.width) img.width = item.width;
        if (item.height) img.height = item.height;
        return img;
      }
      renderFormulaCards() {
        const fragment = document.createDocumentFragment();
        LbbGuidedRoutine.levels.forEach(level => {
          const selected = this.defaults(level);
          const result = LbbGuidedRoutine.resolve(this.catalog, selected);
          const card = this.el('article', 'lbbgr__formula');
          const media = this.el('div', 'lbbgr__formula-media');
          selected.forEach(alias => media.append(this.image(alias)));
          const body = this.el('div', 'lbbgr__formula-body');
          body.append(this.el('h3', '', this.text[level]), this.el('p', 'lbbgr__formula-description', this.text[level + '_description']));
          const price = this.el('p', 'lbbgr__formula-price');
          price.append(this.el('span', '', this.text.composition_price), this.el('strong', '', this.format(result.total)));
          const button = this.el('button', 'lbbgr__secondary', this.state.formula === level ? this.text.adjust_formula : this.text.choose_formula);
          button.type = 'button';
          button.dataset.formulaChoice = level;
          button.setAttribute('aria-pressed', String(this.state.formula === level));
          button.setAttribute('aria-controls', this.q('[data-detail-section]').id);
          button.disabled = this.lock === 'adding';
          if (this.state.formula === level) card.dataset.selected = 'true';
          body.append(price, button);
          if (!result.available) body.append(this.el('p', 'lbbgr__fine', result.missing ? this.text.missing : this.text.unavailable));
          card.append(media, body);
          fragment.append(card);
        });
        this.q('[data-formula-grid]').replaceChildren(fragment);
      }
      chooseFormula(level) {
        if (!LbbGuidedRoutine.levels.includes(level)) return;
        this.changeStarted();
        const family = this.family();
        this.state.formula = level;
        this.state.mask = level !== 'essentiel' ? family.masks[0] : null;
        this.state.finish = level === 'complete' ? family.finishes[0] : null;
        this.q('[data-detail-section]').hidden = false;
        this.q('[data-duo-label]').textContent = this.name(family.key);
        this.q('[data-mask-field]').hidden = level === 'essentiel';
        this.q('[data-finish-field]').hidden = level !== 'complete';
        this.populateSelect('mask', family.masks, this.state.mask);
        this.populateSelect('finish', family.finishes, this.state.finish);
        this.populateSelect('fragrance', LbbGuidedRoutine.fragrances, this.state.fragrance, true);
        this.q('[data-range-note]').textContent = level === 'essentiel' ? '' :
          ['d_match', 'd_lily', 'd_mais'].includes(family.key) ? this.text.multibrand : this.text.mixed_range;
        this.renderFormulaCards();
        this.renderSelection();
        this.focusStep(this.q('[data-detail-heading]'));
      }
      populateSelect(kind, aliases, current, allowEmpty = false) {
        const select = this.q('[data-option="' + kind + '"]');
        select.replaceChildren();
        if (allowEmpty) {
          const empty = this.el('option', '', this.text.no_fragrance);
          empty.value = '';
          select.append(empty);
        }
        aliases.forEach(alias => {
          let label = this.name(alias);
          if (kind === 'fragrance') label = (alias === 'p_rayhanete' ? this.text.hair_mist : this.text.body_splash) + ' · ' + label + ' · +' + this.format(this.catalog[alias]?.price);
          const option = this.el('option', '', label);
          option.value = alias;
          select.append(option);
        });
        select.value = current || '';
      }
      renderSelection() {
        if (!this.state.formula) return;
        const selected = this.selection();
        this.result = LbbGuidedRoutine.resolve(this.catalog, selected);
        const products = document.createDocumentFragment();
        selected.forEach(alias => {
          const li = this.el('li', 'lbbgr__product');
          const media = this.el('div', 'lbbgr__product-image');
          media.append(this.image(alias));
          const body = this.el('div', '');
          const link = this.el(this.catalog[alias]?.url ? 'a' : 'span', '', this.name(alias));
          if (this.catalog[alias]?.url) {
            link.href = this.catalog[alias].url;
            link.target = '_blank';
            link.rel = 'noopener';
          }
          body.append(link);
          if (alias.startsWith('p_')) body.append(this.el('span', 'lbbgr__pill', alias === 'p_rayhanete' ? this.text.hair_mist : this.text.body_splash));
          li.append(media, body);
          products.append(li);
        });
        this.q('[data-products]').replaceChildren(products);
        this.q('[data-summary-formula]').textContent = this.text[this.state.family] + ' · ' + this.text[this.state.formula];
        const lines = document.createDocumentFragment();
        this.result.aliases.forEach(alias => {
          const li = this.el('li', '');
          li.append(this.el('span', '', this.name(alias)), this.el('strong', '', this.format(this.catalog[alias]?.price)));
          lines.append(li);
        });
        this.q('[data-cart-lines]').replaceChildren(lines);
        this.q('[data-kit-note]').hidden = !this.result.usesKit;
        this.q('[data-total]').textContent = this.format(this.result.total);
        const availability = this.q('[data-availability]');
        availability.hidden = this.result.available;
        availability.textContent = this.result.missing ? this.text.missing : this.text.unavailable;
        const add = this.q('[data-add]');
        add.disabled = Boolean(this.config.editor || this.lock || !this.result.available);
        add.textContent = this.config.editor ? this.text.editor_button :
          this.lock === 'adding' ? this.text.adding :
          this.lock === 'success' ? this.text.added : this.text.add;
        this.refreshFamilyControls();
        this.querySelectorAll('[data-option]').forEach(select => { select.disabled = this.lock === 'adding'; });
        this.querySelectorAll('[data-formula-choice]').forEach(button => { button.disabled = this.lock === 'adding'; });
      }
      renderBundleLink() {
        const family = this.family();
        const href = this.config.routes[family.route];
        const link = this.q('[data-bundle-link]');
        link.hidden = !href;
        this.q('[data-bundle-prompt]').hidden = Boolean(href);
        if (href) {
          link.href = href;
          link.target = '_blank';
          link.rel = 'noopener';
        } else link.removeAttribute('href');
      }
      async addRoutine() {
        if (this.config.editor || this.lock || !this.state.formula) return;
        const result = LbbGuidedRoutine.resolve(this.catalog, this.selection());
        if (!result.available || result.missing || !result.aliases.length) return;
        const group = 'lbb-' + (globalThis.crypto?.randomUUID?.() || Date.now().toString(36) + Math.random().toString(36).slice(2));
        const label = this.text[this.state.family] + ' · ' + this.text[this.state.formula];
        const properties = { _lbb_routine: group, [this.text.cart_group]: label };
        const payload = { items: result.aliases.map(alias => ({ id: this.catalog[alias].id, quantity: 1, properties })) };
        this.lock = 'adding';
        this.q('[data-status]').textContent = this.text.adding;
        this.renderSelection();
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(this.config.cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            signal: controller.signal,
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          });
          const data = await response.json();
          if (!response.ok || data.status >= 400 || !Array.isArray(data.items) || !data.items.length) throw new Error('unconfirmed');
          this.lock = 'success';
          this.q('[data-status]').textContent = this.text.success;
          const cartLink = this.q('[data-cart-link]');
          cartLink.textContent = this.text.cart;
          cartLink.href = this.config.cartUrl;
          cartLink.removeAttribute('target');
          cartLink.hidden = false;
          this.q('[data-reset]').hidden = false;
          this.q('[data-reset-note]').hidden = false;
          this.dispatchEvent(new CustomEvent('lbb:routine-added', { bubbles: true, detail: { items: data.items } }));
        } catch {
          this.lock = 'uncertain';
          this.cartChecked = false;
          this.q('[data-status]').textContent = this.text.error;
          const cartLink = this.q('[data-cart-link]');
          cartLink.textContent = this.text.error_cart;
          cartLink.href = this.config.cartUrl;
          cartLink.target = '_blank';
          cartLink.rel = 'noopener';
          cartLink.hidden = false;
          this.q('[data-unlock]').hidden = false;
          this.q('[data-unlock]').disabled = true;
          this.q('[data-unlock-note]').hidden = false;
        } finally {
          clearTimeout(timeout);
          this.renderSelection();
        }
      }
    }
    customElements.define('lbb-guided-routine', LbbGuidedRoutine);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbb-routine-kit-formulas"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('.lbbkf');
  if (!root || root.dataset.compactChat === 'true') return;
  root.dataset.compactChat = 'true';
  let style;
  let frame = 0;
  let attempts = 0;
  let timer = 0;
  const cleanup = () => {
    observer.disconnect();
    clearInterval(timer);
    cancelAnimationFrame(frame);
    style?.remove();
    style = null;
  };
  const compactChat = () => {
    frame = 0;
    if (!root.isConnected) return cleanup();
    const shadow = document.querySelector('shopify-chat')?.shadowRoot;
    if (style && style.parentNode !== shadow) {
      style.remove();
      style = null;
    }
    if (!shadow || style) return;
    style = document.createElement('style');
    style.id = 'lbb-kit-formulas-compact-chat';
    style.textContent = '@media(max-width:749px){.activator-nudge{bottom:calc(8px + env(safe-area-inset-bottom))!important;right:8px!important;width:44px!important;min-width:44px!important;max-width:44px!important;height:44px!important;padding:0!important}.activator-nudge>button.activator[part="activator"]{width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;padding:0!important;gap:0!important;display:flex!important;align-items:center!important;justify-content:center!important}.activator-nudge>button.activator[part="activator"]>.activator__label{position:absolute!important;width:1px!important;height:1px!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important}}';
    shadow.append(style);
    clearInterval(timer);
  };
  const observer = new MutationObserver(() => {
    if (!frame) frame = requestAnimationFrame(compactChat);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  timer = setInterval(() => {
    compactChat();
    if (++attempts >= 40) clearInterval(timer);
  }, 250);
  compactChat();
  window.addEventListener('pagehide', event => {
    if (!event.persisted) cleanup();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
(() => {
  const root = document.querySelector('cart-items.lbb-cart-page');
  if (!root || root.dataset.lbbEnhanced) return;
  root.dataset.lbbEnhanced = 'true';
  const main = root.closest('main');
  if (!main) return;
  let queued = false;
  let mobileBar;
  let barObserver;
  const componentCache = new Map();
  const routineDisclosures = new Map();
  const normalizeTitle = text => String(text || '').replace(/\s+/g, ' ').trim();
  const translatedTitles = new Map();
  const floatingStyles = new Map();
  function compactFloatingControls() {
    const enabled = !root.classList.contains('is-empty');
    const bottom = Math.ceil(mobileBar?.getBoundingClientRect().height || 94) + 10;
    const rules = [
      ['shopify-chat', '.activator-nudge{bottom:'+bottom+'px!important;width:44px!important;min-width:44px!important;max-width:44px!important;height:44px!important;padding:0!important}.activator-nudge>button.activator[part="activator"]{width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;padding:0!important;gap:0!important;display:flex!important;align-items:center!important;justify-content:center!important}.activator-nudge>button.activator[part="activator"]>.activator__label{position:absolute!important;width:1px!important;height:1px!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important}'],
      ['pandectes-cmp', 'button.widget.bottom.left{bottom:'+bottom+'px!important}']
    ];
    rules.forEach(([selector, css]) => {
      const shadow = document.querySelector(selector)?.shadowRoot;
      let style = floatingStyles.get(selector);
      if (style && (!enabled || style.parentNode !== shadow)) {style.remove(); floatingStyles.delete(selector); style=null;}
      if (!enabled || !shadow) return;
      if (!style) {style=document.createElement('style'); style.id='lbb-cart-compact-floating'; shadow.append(style); floatingStyles.set(selector,style);}
      const text='@media(max-width:749px){'+css+'}';
      if (style.textContent !== text) style.textContent=text;
    });
  }
  try {
    const titles = JSON.parse(root.querySelector('[data-lbb-cart-titles]')?.textContent || '{}');
    Object.values(titles).forEach(item => {
      if (item.original && item.title) translatedTitles.set(normalizeTitle(item.original), item.title);
    });
  } catch (_) {}

  function setRoutineDisclosure(group, open) {
    const button = group.querySelector('.bundle-toggle-btn');
    const list = group.querySelector('.bundle-components-list');
    if (!button || !list) return;
    const expanded = String(open);
    if (button.getAttribute('aria-expanded') !== expanded) button.setAttribute('aria-expanded', expanded);
    const display = open ? 'block' : 'none';
    if (list.style.display !== display) list.style.display = display;
    if (list.hidden !== !open) list.hidden = !open;
    const icon = button.querySelector('.toggle-icon');
    if (icon) {
      const transform = open ? 'rotate(180deg)' : 'rotate(0deg)';
      if (icon.style.transform !== transform) icon.style.transform = transform;
    }
  }

  root.addEventListener('click', event => {
    const button = event.target.closest?.('button.bundle-toggle-btn');
    const row = button?.closest('.cart-item.lbb-cart-routine-kit');
    const group = button?.closest('.bundle-components-toggle');
    if (!row || !group) return;
    const data = componentCache.get(row.dataset.lbbLineKey);
    const signature = row.querySelector('.lbb-cart-composition-raw')?.textContent.trim() || '';
    const state = routineDisclosures.get(row.dataset.lbbLineKey);
    if (state?.signature !== signature) return;
    state.open = !state.open;
    if (data?.signature === signature) data.open = state.open;
    queueMicrotask(() => {
      const currentSignature = row.querySelector('.lbb-cart-composition-raw')?.textContent.trim() || '';
      if (group.isConnected && routineDisclosures.get(row.dataset.lbbLineKey) === state && currentSignature === state.signature) {
        setRoutineDisclosure(group, state.open);
      }
    });
  }, true);

  function cachedList(data, key) {
    const disclosure = document.createElement('details');
    disclosure.className = 'lbb-cart-components-fallback';
    disclosure.open = data.open;
    const summary = document.createElement('summary');
    summary.className = 'bundle-toggle-btn';
    const updateSummary = () => {
      summary.textContent = data.routine
        ? (disclosure.open ? root.dataset.hideComponents : root.dataset.showComponents)
        : `${root.dataset.componentsPerKit} (${data.unitCount || data.items.length})`;
    };
    updateSummary();
    disclosure.append(summary);
    const list = document.createElement('ul');
    list.className = 'bundle-components-list list-unstyled';
    data.items.forEach(item => {
      const entry = document.createElement('li');
      entry.className = 'bundle-item';
      if (item.image) {
        const media = document.createElement('div');
        media.className = 'bundle-item-image';
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.alt;
        image.width = image.height = 50;
        image.loading = 'lazy';
        media.append(image);
        entry.append(media);
      }
      const details = document.createElement('div');
      details.className = 'bundle-item-details';
      const info = document.createElement('div');
      info.className = 'bundle-item-info';
      const quantity = document.createElement('span');
      quantity.className = 'bundle-item-quantity';
      quantity.textContent = `${item.quantity} ×`;
      const title = document.createElement('span');
      title.className = 'bundle-item-title';
      title.textContent = item.title;
      info.append(quantity, title);
      details.append(info);
      if (item.variant) {
        const variant = document.createElement('div');
        variant.className = 'bundle-item-variant';
        variant.textContent = item.variant;
        details.append(variant);
      }
      entry.append(details);
      list.append(entry);
    });
    disclosure.append(list);
    disclosure.addEventListener('toggle', () => {
      data.open = disclosure.open;
      const state = data.routine && routineDisclosures.get(key);
      if (state?.signature === data.signature) state.open = disclosure.open;
      updateSummary();
    });
    return disclosure;
  }

  function hairComponents(row) {
    try {
      const expectedParent = row.dataset.lbbHairParentId || '15686016532745';
      if (!['15686016532745', '15689118744841', '15689165406473', '15705118310665', '15705139052809'].includes(expectedParent)) return null;
      const bundle = JSON.parse(row.dataset.lbbHairComposition);
      const components = JSON.parse(row.dataset.lbbHairComponents);
      const parentQuantity = Number(row.querySelector('.quantity__input')?.getAttribute('value'));
      if (!Number.isSafeInteger(parentQuantity) || parentQuantity < 1 || bundle?.v !== 2
        || String(bundle.s?._BS_productId) !== expectedParent || !Array.isArray(bundle.c)
        || !bundle.c.length || !Array.isArray(components) || !components.length) return null;
      const quantities = new Map();
      let unitCount = 0;
      for (const choice of bundle.c) {
        if (!Array.isArray(choice) || !/^[1-9]\d*$/.test(String(choice[0]))
          || !Number.isSafeInteger(choice[1]) || choice[1] < 1) return null;
        const id = String(choice[0]);
        const quantity = (quantities.get(id) || 0) + choice[1];
        unitCount += choice[1];
        if (!Number.isSafeInteger(quantity) || !Number.isSafeInteger(unitCount)) return null;
        quantities.set(id, quantity);
      }
      const metadata = new Map();
      const componentQuantities = new Map();
      for (const component of components) {
        const id = String(component?.variant_id || component?.variant?.id || component?.id || '');
        if (!quantities.has(id) || !Number.isSafeInteger(component.quantity) || component.quantity < 1) return null;
        const componentQuantity = (componentQuantities.get(id) || 0) + component.quantity;
        if (!Number.isSafeInteger(componentQuantity)) return null;
        componentQuantities.set(id, componentQuantity);
        const productTitle = component.product_title || component.product?.title;
        const title = productTitle || component.title;
        if (typeof title !== 'string' || !title.trim()) return null;
        const variant = component.variant_title || component.variant?.title || '';
        const image = typeof component.image === 'string' ? component.image : component.image?.src || component.featured_image?.url || '';
        if (!metadata.has(id)) metadata.set(id, {
          quantity: quantities.get(id), title,
          variant: typeof variant === 'string' && variant !== 'Default Title' && productTitle ? variant : '',
          image: typeof image === 'string' && /^(?:https:\/\/|\/)/.test(image) ? image : '', alt: title
        });
      }
      if (metadata.size !== quantities.size) return null;
      const ids = Array.from(quantities.keys());
      const matchesQuantity = multiplier => ids.every(id => componentQuantities.get(id) === quantities.get(id) * multiplier);
      if (!matchesQuantity(1) && !matchesQuantity(parentQuantity)) return null;
      return {items: ids.map(id => metadata.get(id)), unitCount, routine: false, open: true};
    } catch (_) { return null; }
  }

  function enhanceBundles() {
    root.querySelectorAll('.cart-item').forEach(row => {
      const details = row.querySelector('.cart-item__details');
      if (!details) return;
      if (details.querySelector('[data-lbb-lissage-cart]')) { details.querySelector('.lbb-cart-components-fallback')?.remove(); return; }
      const group = details.querySelector('.bundle-components-toggle');
      const entries = group ? Array.from(group.querySelectorAll('.bundle-components-list .bundle-item')) : [];
      const complete = entries.length > 0 && entries.every(entry => entry.querySelector('.bundle-item-title')?.textContent.trim());
      const key = row.dataset.lbbLineKey;
      const routine = row.classList.contains('lbb-cart-routine-kit');
      const raw = details.querySelector('.lbb-cart-composition-raw');
      const signature = raw?.textContent.trim() || '';
      const bodyKit = row.dataset.lbbBodyKit === 'true';
      const parentQuantity = Number(row.querySelector('.quantity__input')?.getAttribute('value'));
      const validParentQuantity = Number.isSafeInteger(parentQuantity) && parentQuantity > 0;
      let fallback = details.querySelector('.lbb-cart-components-fallback');
      if (row.dataset.lbbHairKit === 'true') {
        const data = hairComponents(row);
        const hairSignature = row.dataset.lbbHairComposition + '\n' + row.dataset.lbbHairComponents;
        if (!data || !key) {
          delete row.dataset.lbbHairGrouped;
          fallback?.remove();
          details.querySelectorAll('.lbb-cart-composition-raw').forEach(node => { node.hidden = false; });
          return;
        }
        if (!fallback || fallback.dataset.lbbLineKey !== key || fallback.dataset.lbbSignature !== hairSignature) {
          fallback?.remove();
          fallback = cachedList(data, key);
          fallback.dataset.lbbLineKey = key;
          fallback.dataset.lbbSignature = hairSignature;
          details.append(fallback);
        }
        row.dataset.lbbHairGrouped = 'true';
        details.querySelectorAll('.lbb-cart-composition-raw').forEach(node => { node.hidden = true; });
        return;
      }
      if (fallback && (fallback.dataset.lbbLineKey !== key || fallback.dataset.lbbSignature !== signature || (bodyKit && !validParentQuantity))) {
        fallback.remove();
        fallback = null;
      }
      if (complete) {
        fallback?.remove();
        fallback = null;
        const button = group.querySelector('.bundle-toggle-btn');
        if (routine && button && key) {
          let state = routineDisclosures.get(key);
          if (state?.signature !== signature) {
            state = {signature, open:true};
            routineDisclosures.set(key, state);
          }
          setRoutineDisclosure(group, state.open);
        }
        if (routine) entries.forEach(entry => {
          const title = entry.querySelector('.bundle-item-title');
          const translated = translatedTitles.get(normalizeTitle(title?.textContent));
          if (title && translated && normalizeTitle(title.textContent) !== normalizeTitle(translated)) {
            (title.querySelector('a') || title).textContent = translated;
            const image = entry.querySelector('.bundle-item-image img');
            if (image) image.alt = translated;
          }
          const variant = entry.querySelector('.bundle-item-variant');
          if (variant) variant.hidden = !variant.textContent.trim();
        });
        const items = entries.map(entry => {
          const image = entry.querySelector('.bundle-item-image img');
          return {
            quantity: Number.parseInt(entry.querySelector('.bundle-item-quantity')?.textContent, 10) / parentQuantity,
            title: entry.querySelector('.bundle-item-title').textContent.trim(),
            variant: entry.querySelector('.bundle-item-variant')?.textContent.trim() || '',
            image: image?.getAttribute('src') || '',
            alt: image?.getAttribute('alt') || ''
          };
        });
        if (key && parentQuantity > 0 && (!bodyKit || validParentQuantity) && items.every(item => Number.isInteger(item.quantity) && item.quantity > 0 && (!bodyKit || item.quantity === 1))) {
          componentCache.set(key, {items, signature, routine, open:group.querySelector('.bundle-toggle-btn')?.getAttribute('aria-expanded') === 'true'});
        }
      } else if (!fallback && key && componentCache.has(key) && (!bodyKit || validParentQuantity)) {
        const data = componentCache.get(key);
        if (data.signature === signature) {
          fallback = cachedList(data, key);
          fallback.dataset.lbbLineKey = key;
          fallback.dataset.lbbSignature = signature;
          details.append(fallback);
        }
      }
      if (fallback && bodyKit) {
        const data = componentCache.get(key);
        const quantities = fallback.querySelectorAll('.bundle-item-quantity');
        quantities.forEach((node, index) => {
          const value = `${data.items[index].quantity * parentQuantity} ×`;
          if (node.textContent !== value) node.textContent = value;
        });
      }
      details.querySelectorAll('.lbb-cart-composition-raw').forEach(raw => {
        const hidden = complete || !!fallback;
        if (raw.hidden !== hidden) raw.hidden = hidden;
      });
      if (!complete) return;
      const button = group.querySelector('.bundle-toggle-btn');
      const label = button?.querySelector('.toggle-text');
      if (button && label) {
        const text = `${button.getAttribute('aria-expanded') === 'true' ? root.dataset.hideComponents : root.dataset.showComponents}${routine ? '' : ` (${entries.length})`}`;
        if (label.textContent !== text) label.textContent = text;
      }
    });
  }

  function syncCheckout() {
    const busy = !!root.querySelector('.cart__items--disabled');
    const empty = root.classList.contains('is-empty');
    const native = main.querySelector('#checkout');
    if (native) {
      if (busy && !native.disabled) {
        native.dataset.lbbBusyLocked = 'true';
        native.disabled = true;
      } else if (!busy && native.dataset.lbbBusyLocked) {
        delete native.dataset.lbbBusyLocked;
        native.disabled = empty;
      }
    }
    main.querySelectorAll('[data-lbb-cart-submit]').forEach(button => {
      const disabled = busy || empty || !native || native.disabled;
      if (button.disabled !== disabled) button.disabled = disabled;
    });
    const nextBar = main.querySelector('.lbb-cart-mobile-bar');
    if (nextBar !== mobileBar) {
      barObserver?.disconnect();
      mobileBar = nextBar;
      if (mobileBar && typeof ResizeObserver !== 'undefined') {
        barObserver = new ResizeObserver(() => {
          const height = mobileBar.getBoundingClientRect().height;
          const value = `${Math.ceil(height || 94)}px`;
          if (document.body.style.getPropertyValue('--lbb-cart-bar-height') !== value) {
            document.body.style.setProperty('--lbb-cart-bar-height', value);
          }
          compactFloatingControls();
        });
        barObserver.observe(mobileBar);
      }
    }
  }

  function update() {
    queued = false;
    enhanceBundles();
    syncCheckout();
    compactFloatingControls();
  }
  const observer = new MutationObserver(() => {
    if (!queued) {
      queued = true;
      requestAnimationFrame(update);
    }
  });
  observer.observe(main, {childList:true, subtree:true, attributes:true, attributeFilter:['class','aria-expanded','disabled']});
  update();
  let floatingAttempts=0;
  const floatingTimer=setInterval(() => {
    compactFloatingControls();
    if (++floatingAttempts >= 40) clearInterval(floatingTimer);
  }, 250);
  window.addEventListener('resize', compactFloatingControls, {passive:true});
})();

  } catch(e) { console.error(e); }
})();
})();
